
function updateButton() {
    const checkbox = document.getElementById("customs-clearance");
    if (!checkbox) return;
    const closestButton = checkbox.closest(".cart-customs-clearance")?.nextElementSibling?.querySelector(".btn-dis-customs-clearance");

    if (closestButton) {
        if (checkbox.checked) {
            closestButton.classList.remove("disabled");
        } else {
            closestButton.classList.add("disabled");
        }
    }
}

document.addEventListener("DOMContentLoaded", updateButton);
window.addEventListener("pageshow", updateButton);
document.getElementById("customs-clearance")?.addEventListener("change", updateButton);

function updateCheckoutButton() {
    const checkbox = document.getElementById("cart-customs-clearance");
    if (!checkbox) return;
    const closestButton = checkbox.closest(".cart-customs-clearance")?.nextElementSibling?.querySelector("#update-cart");
    const closestAdditionalButtons = checkbox.closest(".cart-customs-clearance")?.nextElementSibling?.querySelector(".additional-checkout-buttons");

    if (closestButton) {
        if (checkbox.checked) {
            closestButton.removeAttribute("disabled");
            if(closestAdditionalButtons){
                closestAdditionalButtons.classList.remove('hidden')
            }
        } else {
            closestButton.setAttribute("disabled", "");
            if(closestAdditionalButtons){
                closestAdditionalButtons.classList.add('hidden')
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", updateCheckoutButton);
window.addEventListener("pageshow", updateCheckoutButton);
document.getElementById("cart-customs-clearance")?.addEventListener("change", updateCheckoutButton);

